import produce from "immer";
import AuthService from '../AuthService';
import { EVO } from '../EVO';
import { defaultClinic } from '../defaultValues';
import { urls } from "../urls";

const GET_CLINICS = 'peptalkr/Clinics/GET_CLINICS';
const GET_CLINICS_SUCCESS = 'peptalkr/Clinics/GET_CLINICS_SUCCESS';
const GET_CLINICS_FAILURE = 'peptalkr/Clinics/GET_CLINICS_FAILURE';
const GET_NEW_CLINIC = 'peptalkr/Clinics/GET_NEW_CLINIC';

const GET_CLINIC = 'peptalkr/Clinics/GET_CLINIC';
const GET_CLINIC_SUCCESS = 'peptalkr/Clinics/GET_CLINIC_SUCCESS';
const GET_CLINIC_FAILURE = 'peptalkr/Clinics/GET_CLINIC_FAILURE';

const ADD_CLINIC = 'peptalkr/Clinic/ADD_CLINIC';
const ADD_CLINIC_SUCCESS = 'peptalkr/Clinic/ADD_CLINIC_SUCCESS';
const ADD_CLINIC_FAILURE = 'peptalkr/Clinic/ADD_CLINIC_FAILURE';

export const requestClinics = () => ({ type: GET_CLINICS });
export const receiveClinics = (clinics, id) => ({ type: GET_CLINICS_SUCCESS, clinics, id });
export const receiveClinicsFail = error => ({ type: GET_CLINICS_FAILURE, error });

export const receiveNewClinic = (clinic) => ({ type: GET_NEW_CLINIC, clinic });
export const requestClinic = () => ({ type: GET_CLINIC });
export const receiveClinic = (clinicDetails) => ({ type: GET_CLINIC_SUCCESS, clinicDetails });
export const receiveClinicFail = error => ({ type: GET_CLINIC_FAILURE, error });

export const addClinic = () => ({ type: ADD_CLINIC });
export const addClinicSuccess = clinic => ({ type: ADD_CLINIC_SUCCESS, clinic });
export const addClinicFailure = error => ({ type: ADD_CLINIC_FAILURE, error });

export const fetchclinics = (props) => (dispatch) => {
    const id = EVO.getParamsId(props);
    if (id && id === 'new') {
        dispatch(receiveNewClinic(defaultClinic));
    }
    else if (props && props.clinics) {
        dispatch(receiveClinics(props.clinics, id));
    }
    else {
        const authService = new AuthService();
        if (authService.isAuthenticated()) {
            dispatch(requestClinics());
            EVO.get(urls.api.clinics.getAll.url)
                .then(clinics => {
                    dispatch(receiveClinics(clinics, id));
                })
                .catch(error => dispatch(receiveClinicsFail(error)));
        }
    }
};

export const fetchClinicDetails = (id) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        // TODO: Get Clinic details
        dispatch(requestClinic());
        return EVO.fetch(urls.api.clinics.get(id))
            .then(response => {
                dispatch(receiveClinic(response));
            })
            .catch(error => {
                dispatch(receiveClinicFail(error));
            });
        
    }
};

export const addOrUpdateItem = (item) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(addClinic());
        return EVO.fetch(item.id ? urls.api.clinics.update : urls.api.clinics.add, item)
            .then(response => dispatch(addClinicSuccess(response)))
            .then(response => EVO.success('Item saved!'))
            .catch(error => dispatch(addClinicFailure(error)));
    }
};

const initialState = {
    clinics: null,
    loading: true,
    error: false,
    clinic: defaultClinic,
    clinicDetails: null,
    loadingDetails: true,
    id: null
};

export default produce((draft, action) => {
    switch (action.type) {
        case GET_CLINICS:
            draft.loading = true;
            return;
        case GET_CLINICS_SUCCESS:
            draft.loading = false;
            draft.clinics = action.clinics;
            draft.clinic = EVO.getDetailsItemById(action.clinics, action.id) || defaultClinic;
            draft.id = action.id;
            return;
        case GET_CLINICS_FAILURE:
            draft.loading = false;
            draft.error = action.error;
            return;
        case GET_NEW_CLINIC:
            draft.loading = false;
            draft.clinic = action.clinic;
            return;
        case GET_CLINIC:
            draft.loadingDetails = true;
            draft.clinicDetails = null;
            return;
        case GET_CLINIC_SUCCESS:
            draft.loadingDetails = false;
            draft.clinicDetails = action.clinicDetails;
            return;
        case GET_CLINIC_FAILURE:
            draft.error = action.error;
            draft.clinicDetails = null;
            draft.id = null;
            return;
        case ADD_CLINIC:
            // nothing to do.. Formik handles it
            return;
        case ADD_CLINIC_SUCCESS:
            draft.clinic = action.clinic;
            return;
        case ADD_CLINIC_FAILURE:
            draft.error = action.error;
            return;
        default: return;
    }
}, initialState)


// WEBPACK FOOTER //
// ./src/redux/clinics.js